module.exports = "a {\n  text-decoration: underline !important;\n}\n\n.alertmsj{\n  padding: 15px !important;\n  background-color: #64a664 !important;\n  color: black !important;\n}\n\n.alertmsjerror{\n  padding: 15px !important;\n  background-color: #d9534f !important;\n  color: black !important;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/user/login/login.component.css
// module id = ./src/app/user/login/login.component.css
// module chunks = main